import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { AdinkraBackground } from "../../components/SignupArt/SignupArt";

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="text-xl sm:text-2xl font-bold text-green-600 mb-3">
        {title}
      </h2>
      <div className="space-y-3 text-gray-700 leading-relaxed">{children}</div>
    </section>
  );
}

function List({ children }) {
  return <ul className="list-disc pl-6 space-y-2">{children}</ul>;
}

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Fragment>
      <div class="relative overflow-hidden bg-gradient-to-b h-fit from-white to-gray-100 font-figtree scroll-smooth">
        <AdinkraBackground className="absolute inset-0 overflow-hidden" />
        <div class="mx-auto max-w-7xl pb-8 px-4 sm:px-6 lg:px-8 relative">
          <div class="text-center">
            {/* <h2 class="text-lg font-semibold text-indigo-600"></h2> */}
            <p class="mt-1 text-4xl font-bold tracking-tight text-green-600  sm:text-5xl lg:text-6xl">
              Privacy Policy
            </p>
            <p class="mx-auto mt-5 max-w-xl text-sm text-gray-700">
              If you have an issue with these policies, you can always{" "}
              <a
                className="text-green-500"
                href="mailto:support@tapngogh.com?subject=ENQURIES ABOUT TAPNGO"
              >
                send us an email
              </a>{" "}
              with your enquiry.
            </p>
          </div>
        </div>
      </div>

      <div className="px-4 py-12 font-figtree">
        <p className="text-sm text-gray-500">Last updated: October 8, 2026</p>

        <p className="mt-6 text-gray-700 leading-relaxed">
          This Privacy Policy explains what personal information Tap n' Go
          collects when you use our mobile app, website, USSD service and Tap
          n' Go cards (together, the "Service"), how we use it, who we share it
          with, and the choices and rights you have. Tap n' Go is operated by
          Transport for Ghana (TFG), Accra, Ghana ("we", "us" or "our").
        </p>
        <p className="mt-3 text-gray-700 leading-relaxed">
          We handle personal information in line with Ghana's Data Protection
          Act, 2012 (Act 843). By using the Service, you agree to the practices
          described here. Please also read our{" "}
          <Link to="/terms" className="text-green-600 underline">
            Terms and Conditions
          </Link>
          .
        </p>

        <Section title="1. Information we collect">
          <p>
            <strong>Account information.</strong> Your phone number, and your
            name. When you sign up with only a phone number, we may use the
            name registered to that number with your mobile network to set up
            your account.
          </p>
          <p>
            <strong>Verification codes.</strong> When you sign in, we send a
            one-time code by SMS to confirm that the phone number is yours.
          </p>
          <p>
            <strong>Card and trip information.</strong> The Tap n' Go cards
            linked to your account, their card numbers and nicknames, card
            balances, top-ups, fares paid and the trips or tickets you book.
          </p>
          <p>
            <strong>Payment information.</strong> When you top up with Mobile
            Money, we receive the MoMo number charged, the amount and the
            payment reference and status. We never see or store your MoMo PIN.
          </p>
          <p>
            <strong>Location information.</strong> If you allow it, the app
            uses your device's location to show nearby rides, routes and
            vehicles. For drivers, the app may collect location in the
            background while it is running, so we can match drivers with nearby
            trip requests.
          </p>
          <p>
            <strong>Driver, vehicle owner and merchant information.</strong>{" "}
            If you apply to drive, register a vehicle or become a merchant, we
            collect the details you provide, such as your name, gender, region,
            Ghana Card number, driver's licence, photos and documents you
            upload, vehicle details and driving experience.
          </p>
          <p>
            <strong>Feedback and support.</strong> Information you send us in
            complaints, feedback forms or emails, such as the service you used,
            route, travel time and the contact details you choose to give us.
          </p>
          <p>
            <strong>Device and usage information.</strong> Basic technical
            information such as device type, operating system, app version, IP
            address and how you use the Service, which helps us keep it
            working and secure.
          </p>
        </Section>

        <Section title="2. How we use your information">
          <List>
            <li>To create and manage your account and verify your phone number.</li>
            <li>
              To link your cards, process top-ups and fares, and show your
              balances and history.
            </li>
            <li>To book trips and tickets and connect riders with drivers.</li>
            <li>To review and approve driver, vehicle owner and merchant applications.</li>
            <li>
              To send you service messages, such as verification codes, payment
              confirmations and card link notices.
            </li>
            <li>To respond to your feedback, complaints and support requests.</li>
            <li>
              To prevent fraud, misuse of cards and unauthorised access, and to
              keep the Service secure.
            </li>
            <li>To improve our routes, services and app.</li>
            <li>To meet our legal, accounting and regulatory obligations.</li>
          </List>
        </Section>

        <Section title="3. Who we share your information with">
          <p>We do not sell your personal information. We share it only with:</p>
          <List>
            <li>
              <strong>Payment providers and mobile networks</strong> that
              process Mobile Money payments and send SMS messages for us.
            </li>
            <li>
              <strong>Transport operators and drivers</strong>, only as needed
              to complete a trip or ticket you have booked.
            </li>
            <li>
              <strong>Service providers</strong> that host our systems, store
              files or help us run the Service, under obligations to protect
              your information.
            </li>
            <li>
              <strong>Authorities</strong>, when we are required to by law, or
              to protect the safety of our users, staff or the public.
            </li>
          </List>
        </Section>

        <Section title="4. How long we keep your information">
          <p>
            We keep your information for as long as your account is active and
            as long as needed to provide the Service. After that, we keep only
            what we must for legal, accounting or fraud prevention purposes, and
            then delete or anonymise it.
          </p>
        </Section>

        <Section title="5. How we protect your information">
          <p>
            We use technical and organisational measures to protect your
            information, including encrypted connections, verification codes for
            sign-in and restricted access to personal data. No system is
            completely secure, so please keep your phone and cards safe and
            report a lost or stolen card to us straight away.
          </p>
        </Section>

        <Section title="6. Cookies and browser storage">
          <p>
            When you sign in on our website to link a card or top up, your
            sign-in lasts at most 30 minutes, after which you verify your phone
            number again. We do not use cookies or browser storage for
            advertising.
          </p>
        </Section>

        <Section title="7. Your rights">
          <p>Under the Data Protection Act, 2012 (Act 843), you can:</p>
          <List>
            <li>Ask for a copy of the personal information we hold about you.</li>
            <li>Ask us to correct information that is wrong or incomplete.</li>
            <li>
              Ask us to delete your information, where we are not required to
              keep it.
            </li>
            <li>Object to us using your information for a particular purpose.</li>
            <li>Turn off location access at any time in your device settings.</li>
          </List>
          <p>
            To make a request, email{" "}
            <a href="mailto:support@tapngogh.com" className="text-green-600 underline">
              support@tapngogh.com
            </a>
            . We may ask you to confirm your identity first. If you are not
            satisfied with our response, you can contact the Data Protection
            Commission of Ghana.
          </p>
        </Section>

        <Section title="8. Children">
          <p>
            The Service is for people aged 18 and over. We do not knowingly
            collect personal information from anyone under 18. If you believe a
            child has given us their information, please contact us and we will
            delete it.
          </p>
        </Section>

        <Section title="9. Links to other services">
          <p>
            The Service may link to other websites and services, such as our bus
            ticketing site and app stores. Their own privacy policies apply when
            you use them.
          </p>
        </Section>

        <Section title="10. Changes to this policy">
          <p>
            We may update this Privacy Policy from time to time. When we do, we
            will change the "Last updated" date above, and for significant
            changes we will let you know through the app, website or by SMS.
          </p>
        </Section>

        <Section title="11. Contact us">
          <p>
            For any questions about this Privacy Policy or your personal
            information, contact us:
          </p>
          <List>
            <li>
              By email:{" "}
              <a href="mailto:support@tapngogh.com" className="text-green-600 underline">
                support@tapngogh.com
              </a>
            </li>
          </List>
        </Section>
      </div>
    </Fragment>
  );
}
